function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeNormalIdle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 22,
    viewBox: "0 0 47 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 22,
    rx: 11,
    fill: "#F79009",
    fillOpacity: 0.22,
    style: {
      fill: "#F79009",
      fill: "color(display-p3 0.9686 0.5647 0.0353)",
      fillOpacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 11,
    r: 3,
    fill: "#F79009",
    style: {
      fill: "#F79009",
      fill: "color(display-p3 0.9686 0.5647 0.0353)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3869 6.27273V15H19.0701V6.27273H20.3869ZM24.6525 15.1278C24.1241 15.1278 23.6525 14.9929 23.2377 14.723C22.8258 14.4503 22.502 14.0625 22.2662 13.5597C22.0332 13.054 21.9167 12.4474 21.9167 11.7401C21.9167 11.0327 22.0346 10.4276 22.2704 9.92472C22.5091 9.42187 22.8358 9.03693 23.2505 8.76989C23.6653 8.50284 24.1355 8.36932 24.661 8.36932C25.0673 8.36932 25.394 8.4375 25.6412 8.57386C25.8912 8.70739 26.0843 8.86364 26.2207 9.04261C26.3599 9.22159 26.4679 9.37926 26.5446 9.51562H26.6213V6.27273H27.8954V15H26.6511V13.9815H26.5446C26.4679 14.1207 26.3571 14.2798 26.2122 14.4588C26.0701 14.6378 25.8741 14.794 25.6241 14.9276C25.3741 15.0611 25.0502 15.1278 24.6525 15.1278ZM24.9338 14.0412C25.3002 14.0412 25.6099 13.9446 25.8627 13.7514C26.1184 13.5554 26.3116 13.2841 26.4423 12.9375C26.5758 12.5909 26.6426 12.1875 26.6426 11.7273C26.6426 11.2727 26.5772 10.875 26.4466 10.5341C26.3159 10.1932 26.1241 9.92756 25.8713 9.73722C25.6184 9.54687 25.3059 9.4517 24.9338 9.4517C24.5502 9.4517 24.2306 9.55114 23.975 9.75C23.7193 9.94886 23.5261 10.2202 23.3954 10.5639C23.2676 10.9077 23.2037 11.2955 23.2037 11.7273C23.2037 12.1648 23.269 12.5582 23.3997 12.9077C23.5304 13.2571 23.7235 13.5341 23.9792 13.7386C24.2377 13.9403 24.5559 14.0412 24.9338 14.0412ZM30.9881 6.27273V15H29.714V6.27273H30.9881ZM35.5233 15.1321C34.8784 15.1321 34.323 14.9943 33.8571 14.7188C33.394 14.4403 33.036 14.0497 32.7832 13.5469C32.5332 13.0412 32.4082 12.4489 32.4082 11.7699C32.4082 11.0994 32.5332 10.5085 32.7832 9.99716C33.036 9.4858 33.3883 9.08665 33.84 8.79972C34.2946 8.51278 34.8258 8.36932 35.4338 8.36932C35.8031 8.36932 36.161 8.4304 36.5076 8.55256C36.8542 8.67472 37.1653 8.86648 37.4409 9.12784C37.7164 9.3892 37.9338 9.72869 38.0929 10.1463C38.252 10.5611 38.3315 11.0653 38.3315 11.6591V12.1108H33.1284V11.1562H37.0829C37.0829 10.821 37.0147 10.5241 36.8784 10.2656C36.742 10.0043 36.5502 9.7983 36.3031 9.64773C36.0588 9.49716 35.7718 9.42188 35.4423 9.42188C35.0843 9.42188 34.7718 9.50994 34.5048 9.68608C34.2406 9.85937 34.036 10.0866 33.8912 10.3679C33.7491 10.6463 33.6781 10.9489 33.6781 11.2756V12.0213C33.6781 12.4588 33.7548 12.831 33.9082 13.1378C34.0645 13.4446 34.2818 13.679 34.5602 13.8409C34.8386 14 35.1639 14.0795 35.536 14.0795C35.7775 14.0795 35.9977 14.0455 36.1966 13.9773C36.3954 13.9062 36.5673 13.8011 36.7122 13.6619C36.8571 13.5227 36.9679 13.3509 37.0446 13.1463L38.2505 13.3636C38.1539 13.7187 37.9806 14.0298 37.7306 14.2969C37.4835 14.5611 37.1724 14.767 36.7974 14.9148C36.4252 15.0597 36.0005 15.1321 35.5233 15.1321Z",
    fill: "#F79009",
    style: {
      fill: "#F79009",
      fill: "color(display-p3 0.9686 0.5647 0.0353)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeNormalIdle);
export default __webpack_public_path__ + "static/media/badgeNormalIdle.001751f4318557ce3c94cc02319ef550.svg";
export { ForwardRef as ReactComponent };